import { GraphQLFormattedError } from 'graphql';
import { GraphqlErrorClassification } from './graphql-error-classification.enum';

export function isUnauthorizedError(error: GraphQLFormattedError): boolean {
  return error.extensions?.['classification'] === GraphqlErrorClassification.UNAUTHORIZED;
}
